import { SubscriptionPeriod, SubscriptionType } from "../../payments.model";
import { LiteSubscriptionPricing } from "./pricing.model";

export const LITE_MONTHLY_PRICE = 59;
export const LITE_ANNUAL_PRICE = 39;

export const LITE_PRICE = (subscriptionType: SubscriptionPeriod): number => {
  return subscriptionType === SubscriptionPeriod.Monthly
    ? LITE_MONTHLY_PRICE
    : LITE_ANNUAL_PRICE;
};

export const LITE_SUBSCRIPTION_PRICING: LiteSubscriptionPricing = {
  [SubscriptionType.LiteStarter]: {
    label: "Lite Starter",
    priceMonthly: 29.99,
    priceAnnual: 24.99,
    maxModels: 5,
  },
  [SubscriptionType.Lite]: {
    label: "Lite",
    priceMonthly: 58,
    priceAnnual: 39,
    maxModels: 20,
  },
  [SubscriptionType.LiteStandard]: {
    label: "Lite Standard",
    priceMonthly: 59.99,
    priceAnnual: 39,
    maxModels: 20,
  },
  [SubscriptionType.LitePlus]: {
    label: "Lite Plus",
    priceMonthly: 114.99,
    priceAnnual: 99.99,
    maxModels: 50,
  },
};

export const DEFAULT_LITE_SUBSCRIPTION: SubscriptionType = SubscriptionType.Lite;
